import { render, staticRenderFns } from "./MessageFormTab.vue?vue&type=template&id=654d555c&scoped=true&lang=pug"
import script from "./MessageFormTab.vue?vue&type=script&lang=ts"
export * from "./MessageFormTab.vue?vue&type=script&lang=ts"
import style0 from "./MessageFormTab.vue?vue&type=style&index=0&id=654d555c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d555c",
  null
  
)

export default component.exports